var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

// FIGURE.redirectContinueShopping = function() {
// 	if ($('.page-cart-index').length) {
// 		if ($('.page-cart-index .btn-link').attr('href') === '/wines/') {
// 			$('.page-cart-index .btn-link').attr('href', '/walsonfarms/#shop');
// 		}
// 	}
// }();
//
// FIGURE.renameCartTitle = function() {
// 	if ($('.page-cart-index').length) {
// 		$('.page-cart-index h1.section-title').text('Cart');
// 	}
// }();